module.exports = "/_next/static/images/modalTimerImgSvg-4e33aa7a120496254d2b471436a55ea8.svg";